const scrollMonitor = require('scrollmonitor');
const videoHolders = document.querySelectorAll('.videoHolder');

for (let i = 0; i < videoHolders.length; i++) {
    const videoHolder = videoHolders[i];
    const watcher = scrollMonitor.create(videoHolder);
    watcher.fullyEnterViewport(() => playVideo(videoHolder));
    watcher.exitViewport(() => pausVideo(videoHolder));
}

function pausVideo(el) {
    el.querySelector('.videoHolder__video').pause();
}

function playVideo(el) {
    if (document.body.classList.contains('videoPlayer--active')) return;
    el.querySelector('.videoHolder__video').play();
}



// WEBPACK FOOTER //
// ./src/components/videoHolder/videoHolder.js